import { action, PayloadAction } from 'typesafe-actions';

import { navigationActions, NavigationState } from './navigation.types';

export const saveStep = (data: NavigationState): PayloadAction<string, NavigationState> =>
	action(navigationActions.saveStep, data);
